module.exports = __webpack_public_path__ + "media/img/logos/2024/vatertag-10ad4cf77dc80be17a6bd851e6f82d38.svg";